import { render } from "./FavoriteEmptyIcon.vue?vue&type=template&id=768807c5"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__